import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CrudButtonType } from 'src/app/enum/crud-button-type';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-recovery-fee-workout',
    templateUrl: './recovery-fee-workout.component.html',
    styleUrls: ['./recovery-fee-workout.component.scss']
})
export class RecoveryFeeWorkoutComponent implements OnInit {
    recoveryFeeForm: any;
    CrudButtonType = CrudButtonType;
    showConnectionList: boolean;
    searchtxt: any;
    terminateFeeList: any=[];
    filteredList1: any;
    terminateFee:any

    constructor(private fb: FormBuilder, private serviceChangeRequestService: ServiceChangeRequestService,private cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.init()
    }
    init() {
        this.recoveryFeeForm = this.fb.group({
            searchtxt: [''],
            selectedConnectionDetails: [''],
            referenceNumber: [''],
            fullName: [''],
            fibreType: [''],
            providerName: [''],
            daysUsed: [''],
            daysRemaining: [''],
        });
        this.recoveryFeeForm.disable();
        this.recoveryFeeForm.controls['searchtxt'].enable()
        this.recoveryFeeForm.controls['selectedConnectionDetails'].enable()

    }


    checkifenter(keyEvent) {
        if (keyEvent.which === 13) {
            this.search();
        }
    }

    connectionOnChange() {
        
        const value = this.recoveryFeeForm.value.selectedConnectionDetails;
        console.log(this.recoveryFeeForm.value.selectedConnectionDetails);

        this.terminateFee = this.terminateFeeList.filter(i=>i.serviceChangeReferenceNumber===value)
        console.log(this.terminateFee);
        
        this.recoveryFeeForm.patchValue(this.terminateFee[0])
        this.cdr.detectChanges()
    }

    refresh() {
        this.init()
        this.terminateFee=null
        this.showConnectionList = false
    }

    search() {
        debugger
        if (this.recoveryFeeForm.value.searchtxt) {
            this.serviceChangeRequestService.getTerminationFeeCalculation(this.recoveryFeeForm.value.searchtxt).subscribe((result) => {
                if (result.length > 0) {
                    this.terminateFeeList = result;
                    this.filteredList1 = this.terminateFeeList.slice();

                    if (result.length == 1) {
                        this.terminateFee = result[0];
                        this.recoveryFeeForm.patchValue(this.terminateFee)
                        console.log(this.recoveryFeeForm.value);
                    }
                    else {
                        this.showConnectionList = true;
                    }

                }
                else {
                    var message = "Please enter valid reference number"
                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: true,
                        position: 'center',

                    })
                }
            });
        }
        else {
            var message = "Please enter email reference number to search"
            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: true,
                position: 'center',
            })
        }
    }

}
